import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
      {title}
    </h2>
    <div className="text-sm sm:text-base text-muted-foreground leading-relaxed space-y-2">
      {children}
    </div>
  </section>
);

const TermsOfServicePage = () => (
  <main className="min-h-screen bg-background text-foreground">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors duration-150">
        <ArrowLeft className="w-4 h-4" />
        Back to Home
      </Link>

      <header className="mb-10 border-b border-border pb-8">
        <div className="flex items-center gap-3 mb-4">
          <Shield className="w-8 h-8 text-primary" />
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-muted-foreground">SecureVault</span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Terms of Service
        </h1>
        <p className="text-sm text-muted-foreground mt-3">Last updated: May 2025</p>
      </header>

      <div className="space-y-8">
        <Section title="Acceptance of Terms">
          <p>By using SecureVault, you agree to these Terms of Service.</p>
        </Section>

        <Section title="Description of Service">
          <p>
            SecureVault is a free encrypted file storage service provided as an individual project by Priyanshu Rathod, Dehradun, India.
          </p>
        </Section>

        <Section title="User Responsibilities">
          <p>You agree not to upload illegal content, abuse the service, or provide inaccurate information when using SecureVault.</p>
        </Section>

        <Section title="Prohibited Uses">
          <p>You may not use SecureVault for malware storage, illegal files, system abuse, unauthorized access attempts, or activity that harms the service or other users.</p>
        </Section>

        <Section title="File Storage Limits">
          <p>Files are limited to 50MB per file and use is subject to fair use limits.</p>
        </Section>

        <Section title="Service Availability">
          <p>SecureVault is provided on a best-effort basis. There is no uptime guarantee on the free tier.</p>
        </Section>

        <Section title="Account Termination">
          <p>We may terminate accounts that violate these terms or abuse the service.</p>
        </Section>

        <Section title="Disclaimer of Warranties">
          <p>SecureVault is provided as-is, without warranties of any kind.</p>
        </Section>

        <Section title="Limitation of Liability">
          <p>To the maximum extent permitted by law, SecureVault and its creator are not liable for indirect, incidental, consequential, or data-loss damages arising from use of the service.</p>
        </Section>

        <Section title="Governing Law">
          <p>These terms are governed by the laws of India.</p>
        </Section>

        <Section title="Contact">
          <p>
            For questions about these terms, contact <a href="mailto:security@priyanshurathod.com" className="text-primary hover:underline">security@priyanshurathod.com</a>.
          </p>
        </Section>
      </div>
    </div>
  </main>
);

export default TermsOfServicePage;
